module.exports = __webpack_public_path__ + "img/reset_button_hover.edee5770.svg";